// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductGrid_root__Wswfx","watchlist":"ProductGrid_watchlist__Fb_Hz"};